module.exports = __webpack_public_path__ + "static/img/solution-listL2.0611ecd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution-listL2.png
// module id = Ny+g
// module chunks = 1